angular.module('capability-ng-scheduler').factory('SectionStatusBuilder', function SectionStatusBuilder(Interface) {
  var DTD = {
    section: 'key',
    avail_seats: 'integer',
    status: 'string',
    is_selected: 'boolean',
    is_selected_campus: 'boolean',
    is_droppable: 'boolean',
    is_conflicting: 'boolean',
    is_in_avail: 'boolean',
    has_waitlist: 'boolean',
    num_waitlist: 'integer',
    max_waitlist: 'integer',
    conflicting_section_ids: {
      type: 'array'
    },
    _isWaitListFull: 'boolean'
  };

  function SectionStatusDTO(data) {
    Interface.implement(DTD, data, this);
    calculateWaitlistProperties.call(this);
    removeRedundantConflictingIds.call(this);
  }

  var calculateWaitlistProperties = function calculateWaitlistProperties() {
    this._isWaitListFull = !_.isNull(this.max_waitlist) && this.max_waitlist === this.num_waitlist;
  };

  var removeRedundantConflictingIds = function removeRedundantConflictingIds() {
    this.conflicting_section_ids = _.uniq(this.conflicting_section_ids);
  };

  return SectionStatusDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/section_status_builder.es.js